jQuery(document).ready(function($){

	var Minicalc = {
		sex: 0,
		weight: function() {
			return $('#jq-minicalc-weight').val();
		},
		age: function() {
			return $('#jq-minicalc-age').val();
		},
		height: function() {
			return $('#jq-minicalc-height').val();
		},
		sexWrap: $('#jq-minicalc-sex'),
		wrap: $('#jq-minicalc')
	};

	Minicalc.init = function() {
		Minicalc.sexWrap.find('.jq-minicalc-sex-btn').click(Minicalc._sexHandle);
		Minicalc.wrap.find('.jq-minicalc-helper-btn').click(Minicalc._btnHandle);
		$('#jq-bmi-btn').click(Minicalc._submitHandle);
	};

	Minicalc._sexHandle = function() {
		var $elem = $(this);
		if (Minicalc.sex != 0) {
			Minicalc.sexWrap.find('.jq-minicalc-sex-btn').toggleClass('minicalc-sex--active');
		} else
			$elem.toggleClass('minicalc-sex--active');

		Minicalc.sex = $elem.data('minicalc-sex');
	};

	Minicalc._btnHandle = function() {
		var $input = $(this).parent().find('input');
		var oldValue = $.isNumeric($input.val()) ? $input.val() : 0;
		var newValue = parseInt(oldValue) + parseInt($(this).data('minicalc-unit'));
		newValue = newValue < 1 ? 1 : newValue;
		$input.val(newValue);
	};

	Minicalc._submitHandle = function(e) {
		e.preventDefault();
		if (Minicalc.sex == 0)
			alert('Zadejte vaše pohlaví');
		else if (isNaN(Minicalc.weight()) || isNaN(Minicalc.age()) || isNaN(Minicalc.height()))
			alert('Všechny hodnoty musí být zapsány jako celé číslo.');
		else
			Minicalc._calculate();

		return false;
	};

	Minicalc._calculate = function() {
		var w = Minicalc.weight();
		var h = Math.pow((Minicalc.height() / 100), 2);
		var bmi = w / h;
		var result = {};

		if (bmi <= 16.5) {
			result.heading = 'Máte podváhu';
			result.about = 0;
			result.color = '#99ffff';
		}
		else if (bmi <= 19) {
			result.heading = 'Máte nedostatečnou váhu';
			result.about = 0;
			result.color = '#99ffff';
		}
		else if (bmi <= 25) {
			result.heading = 'Vaše váha je v normě';
			result.about = 1;
			result.color = '#2e9f6e';
		}
		else if (bmi <= 30) {
			result.heading = 'Máte nadváhu';
			result.about = 2;
			result.color = '#edd814';
		}
		else if (bmi <= 35) {
			result.heading = 'Máte mírnou obezitu';
			result.about = 2;
			result.color = '#ef6408';
		}
		else if (bmi <= 40) {
			result.heading = 'Máte střední obezitu';
			result.about = 3;
			result.color = '#a2185b';
		}
		else {
			result.heading = 'Máte klinickou obezitu';
			result.about = 4;
			result.color = '#c3034b';
		}

		var bmiText = 'BMI = ' + Math.round(bmi) + ' - ' + result.heading;
		var optimalText = Math.round(19 * h) + ' - ' + Math.round(25 * h);

		$('#jq-bmi-heading').html(bmiText);
		$('#jq-bmi-optimal').html(optimalText);
		$('#jq-bmi-color').css('background-color', result.color);

		var showAbout = $('#jq-bmi-text .jq-bmi-about');
		showAbout.hide();
		$(showAbout[result.about]).show();

		var dotPosition = Minicalc.convertToPosition(Minicalc.weight(), Minicalc.height())
		$('#jq-bmi-dot').css({
			left: dotPosition.left + '%',
			top: dotPosition.top + '%'
		});

		Minicalc._openDlg();
	};

	Minicalc.convertToPosition = function(weight, height) {
		weight = parseInt(weight);
		height = parseInt(height);

		var w = {
			max: 130,
			min: 40
		};
		var h = {
			max: 210,
			min: 150
		};
		var wRange = w.max - w.min;
		var hRange = h.max - h.min;

		weight = weight > w.max ? w.max : weight;
		weight = weight < w.min ? w.min : weight;
		height = height > h.max ? h.max : height;
		height = height < h.min ? h.min : height;

		var wReal = weight - w.min;
		var hReal = height - h.min;

		weight = (1 - (wReal / wRange)) * 100;
		height = (hReal / hRange) * 100;

		return {
			top: weight,
			left: height
		};
	}

	Minicalc._openDlg = function() {
		$.magnificPopup.open({
			items: {
				type: 'inline',
				src: $('#jq-popup-bmi')
			},
			removalDelay: 205,
			mainClass: 'mfp--text'
		});
	};

	if ($('#jq-minicalc').length == 1)
		Minicalc.init();

});